const numericDefault = (value) =>
  value === undefined || value === null || value === "" ? null : Number(value);

export const getPayrollComponentDefaults = (component) => {
  if (component?.calculationMethod === "Fixed Amount") {
    return {
      amount: numericDefault(component.defaultAmount),
      percentage: null,
    };
  }

  if (component?.calculationMethod?.startsWith("Percentage")) {
    return {
      amount: null,
      percentage: numericDefault(component.defaultPercentage),
    };
  }

  return { amount: null, percentage: null };
};
